/**
 * Template: Collection
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the collection page functionality.
 *
 * @namespace collection
 */
 import {load} from '@shopify/theme-sections';

/* import '~/sections/image-slider'; */
 import '../sections/image-video-hero';
 import '../sections/block-50-50';

 document.addEventListener('DOMContentLoaded', () => {
   load('*');
   document.querySelector('.template-collection__grid').classList.add('hidden');
 });
